import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import Epar from './Epar';
import mapTimeToPrice from './mapTimeToPrice';
import TimeToPrice from './TimeToPrice';

export interface Result {
	epar: Epar;
	items: TimeToPrice[];
}

export default async function findEuropeTimes(client: ApiClient, id: string): Promise<Result> {
	const url = parseTemplate('analytics/virtual-brands/{id}/time-to-price/europe');
	const request = await client.fetch(url.expand({ id }));
	const response = await request.json();

	return {
		epar: new Epar(
			response.epar.marketingAuthorisationDate ? new Date(response.epar.marketingAuthorisationDate) : null
		),
		items: response.items.map(mapTimeToPrice),
	};
}
